"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformVehicleTypePriceFeeToString = transformVehicleTypePriceFeeToString;
const transformVehicleTypeToString_1 = require("./transformVehicleTypeToString");
function transformVehicleTypePriceFeeToString(displayVehicleType, vehicleTypePriceFee, additionalPriceAndFeesAmount) {
    return `${displayVehicleType ? `${(0, transformVehicleTypeToString_1.transformVehicleTypeToString)(vehicleTypePriceFee.vehicleType)}:\xa0` : ""}\u20AC${vehicleTypePriceFee.price + vehicleTypePriceFee.fee + additionalPriceAndFeesAmount}`;
}
//# sourceMappingURL=transformVehicleTypePriceFeeToString.js.map